import { Basecase } from '@scenario/models/basecase.model';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSelector, createSlice } from '@reduxjs/toolkit';

import { RootState } from '@store/create-store';

export interface BasecasesState {
  basecases: Basecase[];
  isFetching: boolean;
  error?: string;
}

const initialState: BasecasesState = {
  basecases: [],
  isFetching: false,
};

export const basecasesSlice = createSlice({
  name: 'basecases',
  initialState,
  reducers: {
    retrieveBasecases: state => {
      state.isFetching = true;
    },
    retrieveBasecasesSuccess: (state, action: PayloadAction<Basecase[]>) => {
      state.basecases = [...action.payload].sort((a, b) => a.name.localeCompare(b.name));
      state.isFetching = false;
    },
    retrieveBasecasesFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isFetching = false;
    },
  },
});

export type BasecasesViewModel = {
  basecases: Basecase[];
  isFetching: boolean;
  error?: string;
};

export const selectBasecasesViewModel = createSelector(
  (state: RootState) => state,
  (state): BasecasesViewModel => ({
    basecases: state.basecases.basecases,
    isFetching: state.basecases.isFetching,
    error: state.basecases.error,
  }),
);
export const { retrieveBasecases, retrieveBasecasesSuccess, retrieveBasecasesFailure } =
  basecasesSlice.actions;

export default basecasesSlice.reducer;
